const DEFAULT_COMMITMENT_TEMPLATE_URL = 'static/123.docx'
const API_BASE = process.env.VUE_APP_BASE_URL || '/wx'
const MEDIA_FILE_PROXY_BASE = `${API_BASE}/media/file?url=`

function isRemoteHttpUrl(value) {
  return /^https?:\/\//i.test(String(value || '').trim())
}

function shouldUseProxy(value) {
  if (!isRemoteHttpUrl(value)) {
    return false
  }
  try {
    const hostname = new URL(String(value).trim()).hostname.toLowerCase()
    return (
      hostname.endsWith('aliyuncs.com') ||
      hostname.endsWith('ykmeik.com') ||
      hostname.endsWith('qlogo.cn') ||
      hostname.endsWith('qpic.cn')
    )
  } catch (error) {
    return false
  }
}

function appendVersion(url, version) {
  if (!version) {
    return url
  }
  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}v=${encodeURIComponent(version)}`
}

function buildDownloadUrl(fileUrl, version = '') {
  const targetUrl = String(fileUrl || '').trim()
  if (!targetUrl) {
    return ''
  }
  if (shouldUseProxy(targetUrl)) {
    const proxied = `${MEDIA_FILE_PROXY_BASE}${encodeURIComponent(targetUrl)}`
    return appendVersion(proxied, version)
  }
  return appendVersion(targetUrl, version)
}

export function resolveDownloadFileName(fileUrl, fallbackName = '原创承诺书') {
  const cleanUrl = String(fileUrl || '').split('?')[0]
  const segments = cleanUrl.split('/')
  return decodeURIComponent(segments[segments.length - 1] || fallbackName)
}

export async function downloadFileByUrl(fileUrl, fallbackName = '原创承诺书', version = '') {
  const targetUrl = String(fileUrl || '').trim()
  if (!targetUrl) {
    throw new Error('下载地址不存在')
  }
  const response = await fetch(buildDownloadUrl(targetUrl, version), {
    cache: 'no-store'
  })
  if (!response.ok) {
    throw new Error('文件下载失败')
  }
  const blob = await response.blob()
  const blobUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = blobUrl
  link.download = resolveDownloadFileName(targetUrl, fallbackName)
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(blobUrl)
}

export function resolveCommitmentTemplateUrl(activity, fallbackUrl = DEFAULT_COMMITMENT_TEMPLATE_URL) {
  const url = String((activity && activity.commitmentTemplate) || '').trim()
  return url || fallbackUrl
}

export { DEFAULT_COMMITMENT_TEMPLATE_URL }
